import { FC } from 'react';
import { Card, CardContent } from '@ibsys/kit';
import { useTranslation } from 'react-i18next';

type Props = {
  consumedMinutes: number;
};

const formatMinutes = (locale: string, value: number) =>
  new Intl.NumberFormat(locale).format(value);

/**
 * Карточка сводной метрики биллинга: суммарный расход минут за выбранный период.
 */
export const BillingStats: FC<Props> = ({ consumedMinutes }) => {
  const { t, i18n } = useTranslation('billing');

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <Card>
        <CardContent className="p-6 flex flex-col gap-2">
          <span className="text-sm text-muted-foreground">{t('consumedMinutes')}</span>
          <span className="text-3xl font-bold">
            {formatMinutes(i18n.language, consumedMinutes)}
          </span>
        </CardContent>
      </Card>
    </div>
  );
};
